jQuery(document).ready(function($){
    $('#dates').change(function () {
        var select_date = $(this).children('option:selected').val();
        $('.selected-date input').val(select_date);
    });
});